var map = {
	"./cannes.png": 3338,
	"./deutscherkamerapreis.png": 2301,
	"./jupiter.png": 5187,
	"./lafa.png": 356,
	"./selb.png": 7856,
	"./shokingshorts.png": 5912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9912;